import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SimpleFlexbox, SimpleAutoCompleteCombo } from 'ctm-components';
import { quoteFormSelector } from 'ctm-selectors';
import classNames from 'classnames';

import { previousInsurersDropDownOptions, getLabelFromCode } from '../../core/state_selectors';
import styles from './previous_insurer.css';

class _PreviousInsurer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inputValue: props.value
        };
    }

    /**
     * The event fired when the suggestion is clicked
     * @param {Event} event The onSelect Event
     * @param {Object} suggestion The suggestion selected
     */
    onSelectProvider = (event, { suggestion }) => {
        const { setProvider } = this.props;
        const code = suggestion.code;
        setProvider(code);
    };

    /**
     * The event fired when the AutoSuggest value is changed
     * @param {Event} event The onChange Event
     * @param {String} newValue The new value that is typed
     */
    onInputChange = (event, { newValue }) => {
        let sanatizedValue = newValue;
        sanatizedValue = sanatizedValue.replace(/[^a-zA-Z0-9&/' ]/ig, '');
        const newState = {
            inputValue: sanatizedValue
        };
        this.setState(newState);
    };

    /**
     * Renders the NonStandardAccessories component
     * @return {Node} Returns the NonStandardAccessories component
     */
    render = () => {
        const { providers } = this.props;
        const { inputValue } = this.state;
        const componentStyles = classNames(styles.auto_suggest_container, styles.suggestionsList);

        return (
            <SimpleFlexbox display="flex" className={styles.accessory_picker_container}>
                <SimpleAutoCompleteCombo
                    placeholder="Start typing..."
                    className={componentStyles}
                    onChange={this.onInputChange}
                    value={inputValue}
                    onSuggestionSelected={this.onSelectProvider}
                    suggestions={providers}
                />
            </SimpleFlexbox>
        );
    };

}

_PreviousInsurer.propTypes = {
    setProvider: PropTypes.func,
    providers: PropTypes.array,
    value: PropTypes.string
};

/**
 * Maps state to props
 * @param {Object} state The redux state
 * @return {Object} Mapped state to props
 */
const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);

    return {
        providers: previousInsurersDropDownOptions(state),
        value: getLabelFromCode(state, 'coverDetail.previousInsurer', 'vertical.quote.apiResponses.previousInsurers') || ''
    };
};

/**
 * @todo: move actions to action creators
 * Map dispatch function to component props
 * @param {Function} dispatch - store's dispatch function
 * @returns {Object} props that contain addAccessory function
 */
const mapDispatchToProps = (dispatch) => ({
    setProvider: (item) => {
        dispatch({
            type: 'SET_VALUE',
            value: item,
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.previousInsurer'
        });
    }
});

const PreviousInsurer = connect(mapStateToProps, mapDispatchToProps)(_PreviousInsurer);

export { PreviousInsurer, _PreviousInsurer };
